import AxiosClient from "../../../services/axios.services";

class AuthBoarningServices {
  getUsersBoarning = (params) =>
    AxiosClient.get(`/api/app/Useronoff/`, {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getGroupsBoarning = () =>
    AxiosClient.get(`/api/app/Group/`, {
      headers: { "Content-Type": "application/json" }
    });
}

export default new AuthBoarningServices();
